import { Button, Typography } from '@mui/material'
import React, { ComponentPropsWithRef } from 'react'
import { useTranslation } from '../i18n/useTranslation'
import { useCommonCtx } from '../context/useCommonCtx'
import { MTypo } from '../components/MTypo/MTypo'

interface Props extends ComponentPropsWithRef<'div'> {
    onClick?: () => void
    onQuit?: () => void
    disabled?: boolean
}
export const Thanks = (p: Props) => {
    const { className, onClick, onQuit, disabled = false, ...rest } = p
    const commons = useCommonCtx()
    const t = useTranslation(commons)
    const slug = commons.slug
    return (
        <div className="flex flex-1 flex-col justify-center items-center gap-6">
            <MTypo variant="h4" className="text-center">
                {t('hint_thanks')}
            </MTypo>
            {/* FIXME */}
            {slug === 'recruitdemo3' && (
                <>
                    <Typography variant="body1" className="text-center">
                        If you already accomplished the other assignment
                        <br />
                        you can now get the success code by opening{' '}
                        <a
                            href="https://tools.fitme.jobs/check.html"
                            target="_blank"
                            rel="noreferrer"
                        >
                            this link
                        </a>
                    </Typography>
                </>
            )}
            <div className="flex flex-col gap-4">
                {!disabled && !!onClick && (
                    <Button variant="outlined" onClick={onClick}>
                        <MTypo variant="h5" className="text-center">
                            {t('btn_download')}
                        </MTypo>
                    </Button>
                )}
                <Button variant="outlined" onClick={onQuit}>
                    <MTypo variant="h5" className="text-center">
                        {t('btn_quit')}
                    </MTypo>
                </Button>
            </div>
        </div>
    )
}
